import { en as baseEn } from '@english/i18n/en';

export const en = {
  ...baseEn,
  meta: {
    ...baseEn.meta,
    appName: 'DIT research',
    locale: 'en-GB',
  },
  header: {
    ...baseEn.header,
    logoAlt: 'Oslo municipality',
    osloLabel: 'Oslo',
  },
  roleSwitcher: {
    ...baseEn.roleSwitcher,
    municipalityName: 'Ingrid Dahl',
    switchToMunicipality: 'Switch to {municipalityName}',
  },
  partnerInbox: {
    ...baseEn.partnerInbox,
    title: 'New request from Oslo municipality',
    intro:
      'Oslo municipality has started an application for DIT research with {partnerName} (identifier {orgnr}) as partner.',
    task2: 'Share eligibility proofs from your business wallet',
    task3: 'Send back to Ingrid Dahl for review',
  },
  step1: {
    ...baseEn.step1,
    title: 'DIT research grant application',
    infoText:
      'This application was started from a DIT research wicked problem. Complete the partner and project details, then use wallet proofs to document eligibility for the selected grant.',
    applyingAs: 'You are applying as a representative of {city}.',
    applyForAnotherLabel: 'Which Oslo unit should receive this pilot?',
    applyForAnotherHint:
      'This is preselected from the wicked problem, but can be changed if another unit should receive the pilot.',
    projectTitlePlaceholder: 'The selected grant has prefilled a suggested project title',
    descriptionLabel: 'What will the grant fund?',
    descriptionPlaceholder: 'Describe how the selected grant will be used in Oslo',
    problemLabel: 'Which wicked problem will this solve?',
    problemPlaceholder: 'Describe the wicked problem that the selected grant addresses',
    partnerSectionHint: 'Select the partner country and identifier to verify the company.',
    sentToPartnerDescription:
      'Waiting for partner to complete attachments and share wallet eligibility proofs.',
  },
  step2: {
    ...baseEn.step2,
    completedBody: 'Switch to Ingrid Dahl to review and complete the application.',
  },
  step3: {
    ...baseEn.step3,
    title: 'Wallet eligibility proofs',
    hintMock:
      'Click Fetch from mock wallet to open the wallet and share proofs. The grant eligibility score updates continuously.',
    completedBody: 'Switch to Ingrid Dahl to review and complete the application.',
  },
  step4: {
    ...baseEn.step4,
    requestedGrant: 'Requested grant from DIT research:',
    warningTitle: 'The collaboration agreement is not signed by Oslo municipality',
    declarationsTitle: 'Self-declaration - Oslo municipality',
    municipalityAgreementFileContext: 'Oslo municipality',
  },
  personalWalletPopup: {
    ...baseEn.personalWalletPopup,
    intro: 'Share your employee certificate from Oslo Municipality to sign in.',
    issuedBy: 'Issued by: Oslo Municipality',
  },
  kommuneSigningPopup: {
    ...baseEn.kommuneSigningPopup,
    subtitle: 'Digital wallet - Oslo municipality',
    signBody: 'You are signing on behalf of Oslo municipality (org.no 958 935 420).',
    contextLabel: 'Oslo municipality',
  },
  budgetDialog: {
    ...baseEn.budgetDialog,
    requestedGrant: 'Requested grant from DIT research',
  },
  domain: {
    ...baseEn.domain,
    declarations: [
      'I understand that this application may become publicly available afterwards.',
      'I confirm that no trade secrets or other sensitive information that cannot be published are included.',
      'I have read and understood the guidelines for using DIT research funds.',
    ],
  },
} as const;

export type OsloCircularFastTrackMessages = typeof en;
